import EventCard from './EventCard';
import EventCardData from './EventCardData';
import SectionHeading from './SectionHeading';
import './Event.css';

const Events = () => {
    return (
        <>
            {/* <!--Causes Section--> */}
            <section className="yk-events" aria-labelledby="yk-events-heading">
                {/* <!-- <div className="icon-one paroller" data-paroller-factor="-0.20" data-paroller-factor-lg="-0.20" data-paroller-factor-sm="-0.10" data-paroller-type="foreground" data-paroller-direction="horizontal"><span className="flaticon-heart-2"></span></div> --> */}

                {/* <!--  <div className="icon-seven paroller" data-paroller-factor="0.30" data-paroller-factor-lg="0.30" data-paroller-factor-sm="0.10" data-paroller-type="foreground" data-paroller-direction="vertical"><span className="flaticon-heart-2"></span></div> --> */}

                <div className="yk-events-container">
                    <SectionHeading 
                        title="Our Events"
                        subtitle="Join us for spiritual gatherings and community celebrations"
                    />

                    <div className="yk-events-grid">
                        {/* <!--Cause Block--> */}
                        {/* <EventCard
                     imgsrc="https://sevastorage.blob.core.windows.net/seva-blob/Yugalkunj_website/event/recent-event1.jpg"
                     Link="#"
                     title="Life Story Of Shri Maharaji In His Own Words"
                     Desc="The first spiritual conference I organized was in Chitrakoot. No conference of the kind had ever been organized before, and it lasted 16 days. Many arguments took place during it. Eventually I had to speak on the stage. There was a speaker by the name Pathik Ji Maharaj; he challenged me. I had ........"
                    /> */}
                        {EventCardData.map((i_event, i_index) => (
                            <EventCard
                                key={i_event.id}
                                i_featured={i_index === 0}
                                imgsrc={i_event.imgsrc}
                                Link={i_event.Link}
                                title={i_event.title}
                                Desc={i_event.Desc}
                            />
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default Events;
